/**
 * `toast({ tone, message })` — fire-and-forget singleton used by mutation
 * handlers in feature files. Until a `<ToastHost>` is mounted the
 * call falls back to a console.info so the build does not break and the
 * developer still sees the message.
 *
 * Kept in `lib/` (not `components/`) so it can be imported anywhere without
 * tripping react-refresh's "components-only file" boundary check.
 */

export type ToastTone = 'success' | 'info' | 'warning' | 'error';

export interface ToastInput {
  tone: ToastTone;
  message: string;
}

type ToastSink = (input: ToastInput) => void;

let activeSink: ToastSink | null = null;

export function registerToastSink(sink: ToastSink | null): void {
  activeSink = sink;
}

export function toast(input: ToastInput): void {
  if (activeSink) {
    activeSink(input);
    return;
  }
  if (typeof console !== 'undefined') {
    console.info(`[toast:${input.tone}]`, input.message);
  }
}
